import React from 'react'
import classNames from 'classnames'

export default function SimpleTableRow({
    children,
    action,
    component,
    ...props
}) {

    const Classes = classNames({
        'table-row w-full items-center border-b border-line last:border-0 hover:bg-light': true,
        'cursor-pointer': action,
    })

    const Component = component || 'div';

    return (
        <Component className={Classes} onClick={action} {...props}>
            {children}
        </Component>
    )
}
